import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { GarageEntity, GarageRequestEntity } from 'src/entities/garageEntity';

export const useMutationGarage = () => {
  const queryClient = useQueryClient();
  return {
    addGarage: useMutation({
      mutationFn: (driver: GarageRequestEntity) => axios.post('/api/v2/garages', driver)
    }),
    updateGarage: useMutation({
      mutationFn: (driver: GarageEntity) => axios.put(`/api/v2/garages/${driver.id}`, driver)
    }),
    deleteGarages: useMutation({
      mutationFn: (ids: number[]) => axios.delete('/api/v2/garages/bulk', { data: { ids } }),

      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: ['trucks']
        });
        void queryClient.invalidateQueries({
          queryKey: ['drivers']
        });
      }
    })
  };
};
